import { SingleAndMultiSelectFieldOption } from 'module/api/field/types';
import { useCallback, useState } from 'react';

type VisibleState = {
  option: SingleAndMultiSelectFieldOption;
  visible: true;
};
type HiddenState = {
  visible: false;
};
type DrawerState = VisibleState | HiddenState;
interface ReturnProps {
  manageOptionInstructionDrawerState: DrawerState;
  closeManageOptionInstructionDrawer: VoidFunction;
  openManageOptionInstructionDrawer: (
    option: SingleAndMultiSelectFieldOption,
  ) => void;
}
export const useManageOptionInstructionDrawerState = (): ReturnProps => {
  const [drawerState, setDrawerState] = useState<DrawerState>({
    visible: false,
  });
  const closeManageOptionInstructionDrawer = useCallback(() => {
    setDrawerState({
      visible: false,
    });
  }, []);
  const openManageOptionInstructionDrawer = useCallback((option: any) => {
    setDrawerState({
      visible: true,
      option,
    });
  }, []);

  return {
    manageOptionInstructionDrawerState: drawerState,
    closeManageOptionInstructionDrawer,
    openManageOptionInstructionDrawer,
  };
};
